/* Örün: aynı gün kargo saati (14 Ekim 2026).
   Hafta içi son saat: Tema ayarları → Kargo ve iade → "Aynı gün kargo için son saat" (16).
   Cumartesi son saat: "Cumartesi son saat" (13). Pazar kargo yok; resmi tatiller dikkate alınmaz.
   tema.js'teki kargoDurumu() fonksiyonunun yerine geçer (bu dosya tema.js'ten sonra yüklenir). */
function kargoDurumu() {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Istanbul", weekday: "short", hour: "numeric", minute: "numeric", hourCycle: "h23" })
    .formatToParts(new Date()).map(x => [x.type, x.value]));
  const gun = p.weekday, dk = +p.hour * 60 + +p.minute;
  const sinir = (gun === "Sat" ? (T.cumartesiKesimSaati || 13) : (T.kesimSaati || 16)) * 60;
  const kargoGunu = gun !== "Sun" && (gun !== "Sat" || T.cumartesiKargo);
  if (kargoGunu && dk < sinir) {
    const kalan = sinir - dk, s = Math.floor(kalan / 60), d = kalan % 60;
    return { bugun: true, kisa: "Bugün kargoda", uzun: `${s ? s + " sa " : ""}${d} dk kaldı` };
  }
  const gunler = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], adlar = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
  let i = gunler.indexOf(gun), fark = 0;
  do { i = (i + 1) % 7; fark++; } while (i === 0 || (i === 6 && !T.cumartesiKargo));
  /* Pazartesi her zaman adıyla yazılır (Pazar ve Cumartesi akşamı: "Pazartesi kargoda") */
  const ertesi = fark === 1 && i !== 1 ? "Yarın" : adlar[i];
  return { bugun: false, kisa: `${ertesi} kargoda`, uzun: "" };
}
sayaclariYaz();
